import React, {useMemo} from 'react';
import moment from 'moment';
import debounce from 'debounce';
import {usePagination, useTable} from 'react-table';
import DataTableView from './DataTable-view';
import ButtonDropdownCommon from "../../../../common/components/ButtonDropdownCommon";
import ButtonDownload from "../ButtonDownload";
import PopupDetails from "../PopupDetails";

const DELAY = 450;

const DataTable = ({
                     data: tableData,
                     totalPages,
                     totalResultCount,
                     page,
                     setPage,
                     columnsList,
                     loading
                   }) => {
  const preparedData = tableData
    .map(item => {
      const {
        id,
        city,
        street,
        blockParcel,
        propertyType,
        decisionType,
        decidingAppraiser,
        effectiveDate,
        decisionDate,
        appraisalType,
        determinedValue,
        area,
        betterment,
        levy,
        localCommittee,
        ...rest
      } = item;

      return {
        address: [city, street].filter(Boolean).join(' / '),
        blockParcel,
        propertyType,
        decisionType,
        decidingAppraiser,
        effectiveDate: (effectiveDate)
          ? moment(effectiveDate).format('DD-MM-YY')
          : '',
        decisionDate: (decisionDate)
          ? moment(decisionDate).format('DD-MM-YY')
          : '',
        appraisalType,
        determinedValue,
        area,
        betterment,
        levy,
        localCommittee,
        actions: (
          <ButtonDropdownCommon
            content={[
              <ButtonDownload id={id}/>,
              <PopupDetails {...item}/>
            ]}
          />
        ),
        ...rest
      };
    })

  const data = useMemo(() => [...preparedData], [tableData]);
  const columns = useMemo(() => [...columnsList], []);
  const tableProps = useTable(
    {
      columns,
      data,
      initialState: {pageIndex: page},
      manualPagination: true,
      pageCount: totalPages,
    },
    usePagination
  );

  const gotoPage = pageIndex => {
    setPage(pageIndex);
    tableProps.gotoPage(pageIndex);
  };

  const nextPage = debounce(() => {
    setPage(page + 1);
    tableProps.nextPage();
  }, DELAY);

  const previousPage = debounce(() => {
    setPage(page - 1);
    tableProps.previousPage();
  }, DELAY);

  const customTableProps = {
    ...tableProps,
    gotoPage,
    nextPage,
    pageIndex: page,
    previousPage,
    totalResultCount,
    showPagination: true,
    allowSorting: false,
    loading
  };

  return (
    <DataTableView {...customTableProps} />
  );
};

export default DataTable;